var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.414 10L14.243 7.172C14.3359 7.07909 14.4096 6.96879 14.4599 6.8474C14.5102 6.726 14.5361 6.5959 14.5361 6.4645C14.5361 6.33311 14.5102 6.203 14.4599 6.0816C14.4096 5.96021 14.3359 5.84991 14.243 5.757C14.1501 5.66409 14.0398 5.59039 13.9184 5.54011C13.797 5.48982 13.6669 5.46394 13.5355 5.46394C13.4041 5.46394 13.274 5.48982 13.1526 5.54011C13.0312 5.59039 12.9209 5.66409 12.828 5.757L10 8.586L7.172 5.757C6.98436 5.56936 6.72986 5.46394 6.4645 5.46394C6.19914 5.46394 5.94464 5.56936 5.757 5.757C5.56936 5.94464 5.46394 6.19914 5.46394 6.4645C5.46394 6.5959 5.48982 6.726 5.54011 6.8474C5.59039 6.96879 5.66409 7.07909 5.757 7.172L8.586 10L5.757 12.828C5.56936 13.0156 5.46394 13.2701 5.46394 13.5355C5.46394 13.8009 5.56936 14.0554 5.757 14.243C5.94464 14.4306 6.19914 14.5361 6.4645 14.5361C6.72986 14.5361 6.98436 14.4306 7.172 14.243L10 11.414L12.828 14.243C13.0156 14.4306 13.2701 14.5361 13.5355 14.5361C13.8009 14.5361 14.0554 14.4306 14.243 14.243C14.4306 14.0554 14.5361 13.8009 14.5361 13.5355C14.5361 13.2701 14.4306 13.0156 14.243 12.828L11.414 10ZM10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20Z",
    fill: "#38AEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCircle);
export default __webpack_public_path__ + "static/media/cancel_circle.80e675cab694c63c6e72b4de96e165e2.svg";
export { ForwardRef as ReactComponent };